import { WSButton, WSFlexBox, WSText } from "@wingspanhq/fe-component-library";
import {
  Currency,
  PayoutDestinationSummaryType,
  PayoutSummary
} from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { PAYOUTS_PATH } from "../../../modules/Payouts";
import { openInNewTab } from "../../../shared/utils/openInNewTab";

export const payoutDestinationLabel = (payout: PayoutSummary): string => {
  const suffix = payout.destination?.last4
    ? ` (${payout.destination.last4})`
    : "";

  switch (payout.destination?.type) {
    case PayoutDestinationSummaryType.INTERNAL_ACCOUNT:
      return "Wingspan Wallet";
    case PayoutDestinationSummaryType.TAX_WITHHOLDING:
      return "Tax Withholding";
    case PayoutDestinationSummaryType.EXTERNAL_BANK_ACCOUNT:
      return `${payout.destination.brand || "Bank account"}${suffix}`;
    case PayoutDestinationSummaryType.PAYMENT_CARD:
      return `${payout.destination.brand || "Debit"}${suffix}`;
    case PayoutDestinationSummaryType.CHECK:
      return "Check";
    case PayoutDestinationSummaryType.GIFT_CARD:
      return "Gift card";
    default:
      return "Paid out";
  }
};

export function payoutToTotals(
  payout: PayoutSummary,
  currency: Currency,
  history: ReturnType<typeof useHistory>
): [ReactNode, ReactNode] {
  const amount = formatMoney(
    payout.amount,
    (payout.currency as Currency) || currency
  );
  const redemptionUrl = payout.destination?.redemptionUrl;

  if (
    payout.destination?.type === PayoutDestinationSummaryType.GIFT_CARD &&
    redemptionUrl
  ) {
    return [
      <WSButton.Link
        key="left"
        size="S"
        rightIcon="open-tab"
        onClick={() => {
          openInNewTab(redemptionUrl);
        }}
      >
        Redeem gift card
      </WSButton.Link>,
      amount
    ];
  }

  return [
    <WSFlexBox key="left" alignItems="center" gap="M">
      <WSText color="gray500">{payoutDestinationLabel(payout)}</WSText>
      {payout.payoutId != null && (
        <WSButton.Link
          size="S"
          rightIcon="open-tab"
          onClick={() => {
            history.push(`${PAYOUTS_PATH}/${payout.payoutId}`);
          }}
        >
          View
        </WSButton.Link>
      )}
    </WSFlexBox>,
    amount
  ];
}
